<div class="create-password-form-wrapper">
  <img src="./assets/images/logo.svg" class="logo" alt="logo" />
  <xos-create-password-form></xos-create-password-form>
</div>
